interface IconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  category?: string;
  inheritLoader?: boolean;
}

function Icon({ name, className = "", style = {}, category = "", inheritLoader }: IconProps) {
  return (
    <div
      className={`icon [--icon:--icon-url] ${inheritLoader ? "icon-inherit-loader" : ""} ${className}`}
      style={{
        "--icon-url": `url(/svg/${category ? `${category}/` : ""}${name}.svg)`,
        ...style,
      }}
    />
  );
}

export default Icon;
